module.exports = __webpack_public_path__ + "img/pago-efectivo.206a1899.svg";